/* Santa Ester theme JS */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ----- Mobile drawer ----- */
  const menuToggle = $('[data-menu-toggle]');
  const drawer = $('[data-mobile-drawer]');
  const overlay = $('[data-drawer-overlay]');
  const closeMenu = $$('[data-menu-close]');

  function openDrawer() { drawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; }

  menuToggle?.addEventListener('click', openDrawer);
  closeMenu.forEach(b => b.addEventListener('click', closeDrawer));
  overlay?.addEventListener('click', () => { closeDrawer(); closeCart(); });

  /* ----- Cart drawer ----- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartOpen = $$('[data-cart-open]');
  const cartClose = $$('[data-cart-close]');

  function openCart() { cartDrawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { cartDrawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; }

  cartOpen.forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); refreshCart(); }));
  cartClose.forEach(b => b.addEventListener('click', closeCart));

  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closeCart(); } });

  /* ----- Cart fetch & render ----- */
  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  function formatMoney(cents) {
    const value = (cents / 100);
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: window.Shopify?.currency?.active || 'CLP', maximumFractionDigits: 0 }).format(value);
    } catch (e) { return '$' + value.toLocaleString('es-CL'); }
  }

  async function refreshCart() {
    if (!cartDrawer) return;
    try {
      const cart = await fetchCart();
      const items = $('[data-cart-items]', cartDrawer);
      const subtotal = $('[data-cart-subtotal]', cartDrawer);
      const counts = $$('[data-cart-count]');
      const totals = $$('[data-cart-total]');

      counts.forEach(el => el.textContent = cart.item_count);
      counts.forEach(el => el.style.display = cart.item_count > 0 ? '' : 'none');
      totals.forEach(el => el.textContent = formatMoney(cart.total_price));

      if (!cart.items.length) {
        items.innerHTML = '<div class="cart-empty"><p>Tu carrito está vacío</p><a href="/collections/all" class="btn btn--outline" data-cart-close>Seguir comprando</a></div>';
        subtotal.textContent = formatMoney(0);
        $$('[data-cart-close]', items).forEach(b => b.addEventListener('click', closeCart));
        return;
      }

      items.innerHTML = cart.items.map(line => `
        <div class="cart-line" data-line-key="${line.key}">
          <div class="cart-line__img"><img src="${line.image || ''}" alt="${line.product_title}"></div>
          <div>
            <div class="cart-line__title"><a href="${line.url}">${line.product_title}</a></div>
            <div class="cart-line__price">${line.quantity} × ${formatMoney(line.price)}</div>
            <a class="cart-line__remove" href="#" data-remove="${line.key}">Eliminar</a>
          </div>
          <div class="cart-line__total">${formatMoney(line.line_price)}</div>
        </div>
      `).join('');

      subtotal.textContent = formatMoney(cart.total_price);

      $$('[data-remove]', items).forEach(a => a.addEventListener('click', async e => {
        e.preventDefault();
        const key = a.getAttribute('data-remove');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        refreshCart();
      }));
    } catch (e) { console.error(e); }
  }

  /* ----- Add to cart (AJAX) ----- */
  $$('form[action="/cart/add"], form[action^="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn?.textContent;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Añadiendo...'; }
      const fd = new FormData(form);
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!r.ok) throw new Error('add fail');
        await refreshCart();
        openCart();
      } catch (err) { console.error(err); alert('No se pudo añadir el producto.'); }
      finally { if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; } }
    });
  });

  /* ----- Quantity inputs ----- */
  $$('.qty-input').forEach(wrap => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || 1, 10) - 1);
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || 1, 10) + 1;
    });
  });

  /* ----- Product gallery ----- */
  $$('[data-gallery]').forEach(gal => {
    const main = gal.querySelector('[data-gallery-main] img');
    const thumbs = $$('[data-gallery-thumb]', gal);
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
        const src = t.querySelector('img').dataset.full || t.querySelector('img').src;
        main.src = src;
      });
    });
  });

  /* ----- Product tabs ----- */
  $$('[data-tabs]').forEach(tabs => {
    const buttons = $$('[data-tab]', tabs);
    const panels = $$('[data-panel]', tabs);
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.tab;
        buttons.forEach(b => b.classList.toggle('is-active', b === btn));
        panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === id));
      });
    });
  });

  /* ----- Banner slider ----- */
  $$('[data-slider]').forEach(slider => {
    const slides = $$('[data-slide]', slider);
    if (slides.length <= 1) return;
    const dots = $$('[data-slider-dot]', slider);
    const prev = $('[data-slider-prev]', slider);
    const next = $('[data-slider-next]', slider);
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = parseInt(slider.dataset.interval, 10) || 6000;
    let index = 0;
    let timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    }
    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => go(index + 1), interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    prev?.addEventListener('click', () => { go(index - 1); start(); });
    next?.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach(d => d.addEventListener('click', () => {
      go(parseInt(d.dataset.sliderDot, 10));
      start();
    }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    // Touch swipe
    let startX = null;
    slider.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', e => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      startX = null;
      start();
    });

    start();
  });

  /* ----- Accordion (product page) ----- */
  $$('[data-accordion]').forEach(acc => {
    const triggers = $$('[data-accordion-trigger]', acc);
    triggers.forEach(trigger => {
      const panel = trigger.nextElementSibling;
      if (panel && trigger.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      trigger.addEventListener('click', () => {
        const isOpen = trigger.classList.toggle('is-open');
        if (isOpen) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = '0px';
        }
      });
    });
  });

  /* ----- Variant picker ----- */
  $$('[data-variant-form]').forEach(form => {
    const variantData = JSON.parse(form.querySelector('[data-variant-json]')?.textContent || '[]');
    const idInput = form.querySelector('[name="id"]');
    const priceEl = $('[data-product-price]');
    const stockEl = $('[data-product-stock]');
    const submit = form.querySelector('[type="submit"]');

    function updateVariant() {
      const selected = $$('select[data-option]', form).map(s => s.value);
      const variant = variantData.find(v => v.options.every((opt, i) => opt === selected[i]));
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stockEl) {
        if (variant.available) {
          stockEl.textContent = (variant.inventory_quantity > 0 ? variant.inventory_quantity + ' disponibles' : 'En stock');
          stockEl.classList.add('in-stock');
          submit.disabled = false;
          submit.textContent = 'Añadir al carrito';
        } else {
          stockEl.textContent = 'Agotado';
          stockEl.classList.remove('in-stock');
          submit.disabled = true;
          submit.textContent = 'Agotado';
        }
      }
    }
    $$('select[data-option]', form).forEach(s => s.addEventListener('change', updateVariant));
  });

  /* ----- Age gate ----- */
  const ageGate = $('[data-age-gate]');
  const ageDeny = $('[data-age-deny]');
  if (ageGate && !sessionStorage.getItem('ester_age_ok')) {
    ageGate.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  $('[data-age-yes]')?.addEventListener('click', () => {
    sessionStorage.setItem('ester_age_ok', '1');
    ageGate.classList.remove('is-open');
    document.body.style.overflow = '';
  });
  $('[data-age-no]')?.addEventListener('click', () => {
    ageGate.classList.remove('is-open');
    ageDeny?.classList.add('is-open');
  });

  /* ----- Init ----- */
  refreshCart();
})();
